// StyledLabel.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledLabelBase = styled.label`
  outline: none;
  padding: 0 ${({ styling }) => `${styling.fieldLabelPadding}px`};
  font-size: ${({ styling }) => `${styling.fieldLabelFontSize}px`};
  font-weight: ${({ styling }) => styling.fieldLabelFontWeight};
  font-family: ${({ styling }) => styling.fieldLabelFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  margin-bottom: ${({ styling }) => styling.fieldLabelBottomSpacing}px;
  color: ${({ styling }) => styling.fieldLabelColor};
  background-color: ${({ styling }) => styling.fieldLabelBackgroundColor};

`;

const StyledLabel = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledLabelBase {...props} placeholder={placeholderText} />;
};



export default StyledLabel;
